import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue";
import { useElementSize } from "@vueuse/core";
import { ref, computed } from "vue";
import MasonryListItem from "./MasonryListItem.vue";
const gridAutoRows = 1;
const gridRowGap = 30;
const minimumColumnWidth = 275;
const minimumColumnCount = 1;
const maximumColumCount = 5;
export default /*#__PURE__*/ _defineComponent({
    __name: 'MasonryList',
    props: {
        items: {},
        negativeMargin: { default: 0 }
    },
    setup(__props) {
        const props = __props;
        const grid = ref(null);
        const containerWidth = useElementSize(grid).width;
        const columnCount = computed(() => {
            const maxColumnsThatWillFit = Math.floor(containerWidth.value / minimumColumnWidth);
            if (maxColumnsThatWillFit < minimumColumnCount) {
                return minimumColumnCount;
            }
            if (maxColumnsThatWillFit > maximumColumCount) {
                return maximumColumCount;
            }
            return maxColumnsThatWillFit;
        });
        const gridStyle = computed(() => {
            return {
                "grid-template-columns": `repeat(${columnCount.value}, minmax(0, 1fr))`,
                "grid-row-gap": `${gridRowGap}px`,
                "grid-auto-rows": `${gridAutoRows}px`,
                "grid-column-gap": `${gridRowGap}px`,
            };
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "masonry-container",
                ref_key: "grid",
                ref: grid,
                style: _normalizeStyle(gridStyle.value)
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                    return (_openBlock(), _createBlock(MasonryListItem, {
                        "is-shown": item.isShown(),
                        key: item.id,
                        "grid-auto-rows": gridAutoRows,
                        "grid-row-gap": gridRowGap,
                        "negative-margin": _ctx.negativeMargin
                    }, {
                        default: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "item", _normalizeProps(_guardReactiveProps(item)))
                        ]),
                        _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["is-shown", "negative-margin"]));
                }), 128 /* KEYED_FRAGMENT */))
            ], 4 /* STYLE */));
        };
    }
});
